import { useAppSelector } from '../../app/hooks';
import { selectTemplatesAndCombinedOntology } from '../../data/templateSlice';
import styles from './StartPage.module.scss';
import { StartPageViewFactory } from './StartPageViewFactory';

export function StartPage() {
  const { ontology, startPageViews } = useAppSelector(selectTemplatesAndCombinedOntology);

  return Object.keys(startPageViews).length > 0 ? (
    <div className={styles.wrapper}>
      <StartPageViewFactory startPageViews={startPageViews} ontology={ontology} />
    </div>
  ) : (
    <div className={styles.error}>
      <pre>No start page views defined, please contact your administrator.</pre>
    </div>
  );
}
